import { render, staticRenderFns } from "./SoftwareUpdates.vue?vue&type=template&id=216fe120&"
import script from "./SoftwareUpdates.vue?vue&type=script&lang=js&"
export * from "./SoftwareUpdates.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareUpdates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports